<template>
  <section class="lublin-page__first-section">
    <div class="lublin-page__first-section-figure-side">
      <div class="lublin-page__first-section-content">
        <div class="lublin-page__first-section-content-row">
          <h1 v-html="sectionData.labels[0]" class="lublin-page__first-section-title"></h1>
          <img
            class="lublin-page__first-section-organization-logo"
            width="145"
            :src="sectionData.image1"
            alt="organization-logo"
          >
        </div>

        <h2 class="lublin-page__city-title">{{ sectionData.labels[1] }}</h2>
      </div>
    </div>
    <img
      class="lublin-page__fest-bg-image"
      :src="sectionData.image2"
      alt="lublin-fest-image"
    >

    <div class="lublin-page__first-section-text-figure">
      <p class="text">{{ sectionData.labels[2] }}</p>
    </div>
    <div class="lublin-page__first-section-top-figure"></div>
  </section>
</template>

<script>
export default {
  name: 'LublinFirstSection',
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
  },
};
</script>
